import PropTypes from 'prop-types';
import React from 'react';

const defaultSize = 24;

const createImageIcon = ({displayName, path}) => (class extends React.Component {
  static displayName = displayName;

  static propTypes = {
    style: PropTypes.object,
  };

  render() {
    const {style, ...rest} = this.props;
    const defaultStyle = {height: defaultSize, width: defaultSize};
    return (
      <img
        src={path}
        style={Object.assign(defaultStyle, style)}
        {...rest}
      />
    );
  }
});

export default createImageIcon;



// WEBPACK FOOTER //
// ./src/common/components/icons/createImageIcon.js